import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import browserHistory from '../../util/browserHistory';
import { formattedLastLoginMessage } from '../../util/users';
import { createSelector } from 'reselect';

import { invalidate, logout } from '../../actions/api/auth';
import { update, navigate, store } from '../../actions/app';
import { getNotifications } from '../../actions/api/notifications';
import { getUser } from '../../actions/api/user';
import { getTeam } from '../../actions/api/team';
import { resetNewlyAuthenticated } from '../../actions/session';
import ENV from '../../env';
import App from '../../components/x/App';
import performanceContainer from '../../performanceContainer';

import { format } from '../../util/url';
import { toast, clearToast } from '../../actions/toast';

import {
  page as getPage,
  parsedQueryText as queryText
} from '../../selectors/app';
import { notificationsList } from '../../selectors/entities';
import {
  fullName,
  isTeamAdmin,
  isTeamOwner,
  teamName,
  username,
  userThumbnail,
  newlyAuthenticated,
  newlyAuthenticatedSSO
} from '../../selectors/session';
import {
  aiModelEnabled,
  frontEndPerformanceMonitoringEnabled,
  splitPaneEnabled,
  watchListEnabled,
  workDoneBetterNavigationEnabled
} from '../../selectors/feature';

const selectUnreadNotifications = createSelector(
  notificationsList,
  (notificationsList = []) =>
    notificationsList.filter(notification => notification.read === false)
);

const embeddedMode = JSON.parse(ENV.PUSHBOT_EMBEDDED_MODE);

export default connect(
  (state, props) => ({
    ...getPage(state, props),
    aiModelEnabled: aiModelEnabled(state),
    frontEndPerformanceMonitoringEnabled: frontEndPerformanceMonitoringEnabled(
      state
    ),
    fullName: fullName(state),
    isTeamAdmin: isTeamAdmin(state),
    isTeamOwner: isTeamOwner(state),
    queryText: queryText(state),
    teamName: teamName(state),
    unreadNotifications: selectUnreadNotifications(state),
    username: username(state),
    userThumbnail: userThumbnail(state),
    splitPaneEnabled: splitPaneEnabled(state),
    watchListEnabled: watchListEnabled(state),
    workDoneBetterNavigationEnabled: workDoneBetterNavigationEnabled(state),
    newlyAuthenticated: newlyAuthenticated(state),
    newlyAuthenticatedSSO: newlyAuthenticatedSSO(state)
  }),
  dispatch => ({
    onDidMount: ({
      teamName,
      username,
      newlyAuthenticated,
      newlyAuthenticatedSSO,
      intl: { formatMessage } = {}
    }) => {
      if (username) {
        return Promise.all([
          dispatch(getUser({ teamName, username })),
          dispatch(getTeam({ teamName })),
          dispatch(getNotifications({ teamName, username, read: false }))
        ]).then(results => {
          const {
            response: {
              entities: { teams = {} }
            }
          } = results[1];
          const team = teams[teamName];
          const ssoEnabled = team && team.samlConfig && team.samlConfig.enabled;
          if (newlyAuthenticated || (ssoEnabled && newlyAuthenticatedSSO)) {
            const {
              response: {
                entities: { users = {} },
                result: userID
              }
            } = results[0];
            const { lastLogin } = users[userID];

            dispatch(resetNewlyAuthenticated());
            if (lastLogin) {
              const message = formattedLastLoginMessage(
                lastLogin,
                formatMessage
              );
              return dispatch(toast({ message, autoHideDuration: 10000 }));
            }
          }
        });
      } else {
        return Promise.resolve();
      }
    },
    onNavigation: () => dispatch(navigate()),
    onSearchReset: (text, terms, location) =>
      browserHistory.push(format(location)),
    onSearchSubmit: (text, terms, location) =>
      browserHistory.push(format(location)),
    onSignOut: ({ teamName, username }) => {
      dispatch(logout({ teamName, username }));
      dispatch(invalidate());
      dispatch(clearToast());
      embeddedMode
        ? browserHistory.push('/auth')
        : browserHistory.push('/login');
    },
    store: (nextProps, merge, path) => dispatch(store(nextProps, merge, path)),
    update: (nextProps, merge, path) => dispatch(update(nextProps, merge, path))
  })
)(performanceContainer(injectIntl(App)));



// WEBPACK FOOTER //
// ./js/modules/x/App.js